export default {
  table: {
    borderSpacing: 0,
    color: '#333333',
    fontFamily: 'sans-serif',
  },
  innerTable: {
    margin: '0 auto',
    borderSpacing: '0',
    maxWidth: '642px',
    width: '100%',
  },
  innerTable_tableCell: {
    fontSize: '0',
    padding: '0',
    textAlign: 'center',
  },
}
